import { render, staticRenderFns } from "./DoorMaintenanceReportItemView.vue?vue&type=template&id=50621a6a&"
import script from "./DoorMaintenanceReportItemView.vue?vue&type=script&lang=js&"
export * from "./DoorMaintenanceReportItemView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports